<div class="scv2-root" *ngIf="!isLoadingShippingState; else scv2GateLoading">
  <!-- sub-tab strip -->
  <div *ngIf="enabled" class="scv2-subtabs scv2-no-print">
    <!-- TODO re-enable UPS: Settings / Shipping / UPS &amp; USPS integration -->
    <div class="scv2-breadcrumb">Settings / Shipping / USPS integration</div>
    <div class="scv2-subtab-row">
      <button
        type="button"
        *ngFor="let t of subTabs"
        class="scv2-subtab"
        [class.scv2-active]="activeSubTab === t.id"
        (click)="setSubTab(t.id)"
      >
        {{ t.label }}
      </button>
    </div>
  </div>

  <!-- master "do you ship?" gate -->
  <div class="scv2-gate scv2-no-print">
    <div>
      <div class="scv2-gate-title">Do you ship products?</div>
      <p class="scv2-gate-sub">
        <!-- TODO re-enable UPS + labels: Turn this on to connect UPS/USPS, set shipping rates, and buy + print labels from LincSell. -->
        Turn this on to connect USPS and set shipping rates for your store.
      </p>
    </div>
    <app-toggle-v2 [checked]="enabled" [disabled]="isTogglingShipping" (checkedChange)="onEnabledToggleRequested($event)"></app-toggle-v2>
  </div>

  <!-- off state -->
  <div *ngIf="!enabled" class="scv2-offstate">
    <div class="scv2-offstate-icon"><i class="pi pi-truck"></i></div>
    <div class="scv2-offstate-title">Shipping is turned off</div>
    <p class="scv2-offstate-sub">
      <!-- TODO re-enable labels: originally "...connect a carrier and start buying labels." -->
      Customers won't see shipping options at checkout until you turn this on. Once enabled, connect a carrier and set your shipping rates.
    </p>
    <button type="button" class="scv2-btn-primary" [disabled]="isTogglingShipping" (click)="onEnabledToggleRequested(true)"><i class="pi pi-truck"></i> Enable shipping</button>
  </div>

  <!-- enabled content -->
  <ng-container *ngIf="enabled">
    <app-shipping-carrier-setup-v2 *ngIf="activeSubTab === 'carriers'" (goToRules)="setSubTab('rules')"></app-shipping-carrier-setup-v2>
    <app-shipping-rules-v2 *ngIf="activeSubTab === 'rules'" (goToCarriers)="setSubTab('carriers')"></app-shipping-rules-v2>
    <app-shipping-labels-dashboard-v2 *ngIf="activeSubTab === 'dashboard'"></app-shipping-labels-dashboard-v2>
  </ng-container>
</div>

<ng-template #scv2GateLoading>
  <div class="scv2-gate scv2-no-print">
    <div>
      <p-skeleton width="10rem" height="1rem" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="22rem" height="0.75rem"></p-skeleton>
    </div>
    <p-skeleton width="3rem" height="1.5rem"></p-skeleton>
  </div>
</ng-template>
